import { render } from "./Mosaico.vue?vue&type=template&id=2e5239c2"
import script from "./Mosaico.vue?vue&type=script&lang=js"
export * from "./Mosaico.vue?vue&type=script&lang=js"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__